<template>
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.5 24H16.5V19.5H21V16.5H16.5V12H13.5V16.5H9V19.5H13.5V24ZM6 30C5.175 30 4.469 29.7065 3.882 29.1195C3.295 28.5325 3.001 27.826 3 27V9C3 8.175 3.294 7.469 3.882 6.882C4.47 6.295 5.176 6.001 6 6H24C24.825 6 25.5315 6.294 26.1195 6.882C26.7075 7.47 27.001 8.176 27 9V15.75L33 9.75V26.25L27 20.25V27C27 27.825 26.7065 28.5315 26.1195 29.1195C25.5325 29.7075 24.826 30.001 24 30H6ZM6 27H24V9H6V27Z"
            fill="currentColor" />
    </svg>
</template>